import { useState } from 'react';
import { cn } from 'lib/cn';
import env from 'config/env';
import { StoreIcon } from 'components/icons';
import logo from '../../assets/logo.png';

const DIMENSIONS = { sm: 'h-9 w-9', md: 'h-11 w-11', lg: 'h-14 w-14' };
const ICON_SIZES = { sm: 'h-5 w-5', md: 'h-6 w-6', lg: 'h-7 w-7' };

/**
 * Brand mark. Shows the bundled logo (`src/assets/logo.png`) by default, lets
 * `REACT_APP_LOGO_URL` override it (e.g. a file in public/), and falls back to
 * the built-in store icon if the image fails to load.
 */
export function Brand({ size = 'md', className }) {
  const [imageFailed, setImageFailed] = useState(false);
  const logoSrc = env.logoUrl || logo;
  const showImage = Boolean(logoSrc) && !imageFailed;

  if (showImage) {
    return (
      <img
        src={logoSrc}
        alt="Quro"
        onError={() => setImageFailed(true)}
        className={cn('rounded-2xl object-contain', DIMENSIONS[size], className)}
      />
    );
  }

  return (
    <span
      className={cn(
        'flex items-center justify-center rounded-2xl bg-brand-600 text-white',
        DIMENSIONS[size],
        className,
      )}
    >
      <StoreIcon className={ICON_SIZES[size]} />
    </span>
  );
}

export default Brand;
